import React from 'react';
import { Header } from '../component';
import { Outlet } from 'react-router';
export const AuthorizeLayout = () => {
  return (
    <>
      <Header />
      <main
        className="bg-third-light min-vh-100 position-relative"
        style={{
          top: 64,
        }}
      >
        <Outlet />
      </main>
    </>
  );
};
export default AuthorizeLayout;
